import firebase from 'firebase';
import store from '@/store';
import router from '@/router';
import 'firebase/firestore';
import 'firebase/database';

const config = {
    apiKey: "AIzaSyDkg2SNqn28AWlHpEx461pt1bCh7hTQn2Y",
    authDomain: "missionshare-2f93c.firebaseapp.com",
    databaseURL: "https://missionshare-2f93c.firebaseio.com",
    projectId: "missionshare-2f93c",
    storageBucket: "missionshare-2f93c.appspot.com",
    messagingSenderId: "2287298797",
    appId: "1:2287298797:web:47f7f2e8f7d19b704404e4",
    measurementId: "G-WLMZKLTGR7"
};
firebase.initializeApp(config);

//alert('Add to firebase Y');
//firebase.database().ref('surveys').push({Paddington:{time:now}});
//firebase.database().ref('surveys').on('child_added', snapshot => {
    //alert('Found Survey Y');
//});

firebase.auth().onAuthStateChanged( user => {
    //alert('FB index')
    store.commit('setUser', user);
    store.dispatch('listenForUserCore',false);
    //store.dispatch('listenForContacts');
    if (!user)
        store.commit('setIsAuthenticated', false);
    else
        store.commit('setIsAuthenticated', true);
    store.commit('setInitialChecked', true);
    router.push('/');
});



